import { CheckCardAccounts } from "./check-card-accounts";
import { CardCheckSummary } from "./check-card-summary";
import { CheckImageUnavailable } from "./check-image-unavailable";
import { CheckImageViewer } from "./check-image-viewer";
import type { CheckVm } from "./checks-page.utils";

export function ChecksDialogContent({ data }: { data: CheckVm }) {
  return (
    <div className="grid gap-20px py-10px sm:grid-cols-2 sm:items-start sm:gap-30px sm:last:*:has-[button[data-state]]:pt-50px">
      <div>
        {data.userHasAllAccounts ? (
          <CheckImageViewer checkId={data.id} />
        ) : (
          <CheckImageUnavailable />
        )}
      </div>
      <div className="grid gap-20px sm:gap-30px">
        <CardCheckSummary data={data} />
        <CheckCardAccounts data={data} />
      </div>
    </div>
  );
}
